import { Icon, IconProps } from "@chakra-ui/icons";

const TriagleUpIcon = (props: IconProps) => {
  return (
    <Icon width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M3.35939 8C3.25159 8 3.16474 7.9558 3.09885 7.8674C3.03295 7.77916 3 7.67616 3 7.55841C3 7.52889 3.03719 7.42669 3.11157 7.25183L5.61834 4.20204C5.67588 4.13187 5.73541 4.08066 5.79694 4.04839C5.85846 4.01613 5.92615 4 6 4C6.07385 4 6.14154 4.01613 6.20306 4.04839C6.26458 4.08066 6.32412 4.13187 6.38166 4.20204L8.88862 7.25183C8.9231 7.29393 8.95028 7.34096 8.97017 7.3929C8.99006 7.44468 9 7.50025 9 7.55961C9 7.67818 8.96705 7.78126 8.90115 7.86885C8.83526 7.95628 8.74841 8 8.64061 8H3.35939Z"
        fill="currentcolor"
      />
    </Icon>
  );
};

export default TriagleUpIcon;
